
// Getter Object for AccountsRoyalty. Use it by calling mapGetters from the Vuex Host Components.

export const licenceGetters = {
  licencesData: (state) => state.licencesData,
  licencesList: (state)=> state.licencesList,
  licencesDetails: (state)=> state.licencesDetails,
}


